// data.js
import aiData from './data/ai.json';
import gcpData from './data/gcp.json';
import networkingData from './data/networking.json';
import pythonData from './data/python.json';
import linuxData from './data/linux.json';
import {
  FaBrain,
  FaChartLine,
  FaNetworkWired,
  FaCloud,
  FaDatabase,
  FaTerminal,
  FaCogs,
  FaCode,
  FaRoute,
  FaPython,
  FaLinux,
  FaExchangeAlt,
  FaKey,
  FaLayerGroup,
  FaSitemap,
  FaObjectGroup,
  FaSyncAlt,
  FaFolderOpen,
  FaCubes,
  FaFileAlt,
  FaExclamationTriangle,
  FaCube,
  FaProjectDiagram,
  FaRegLightbulb,
  FaWaveSquare,
  FaPlayCircle,
  FaKeyboard,
  FaGlobe,
  FaMemory
} from "react-icons/fa"; 

import { SiGooglecloud } from "react-icons/si";

const iconMap = {
  FaBrain,
  FaChartLine,
  FaNetworkWired,
  FaCloud,
  FaDatabase,
  FaTerminal,
  FaCogs,
  FaCode,
  FaRoute,
  FaPython,
  FaLinux,
  FaExchangeAlt,
  FaKey,
  FaLayerGroup,
  FaSitemap,
  FaObjectGroup,
  FaSyncAlt,
  FaFolderOpen,
  FaCubes,
  FaFileAlt,
  FaExclamationTriangle,
  FaCube,
  FaProjectDiagram,
  FaRegLightbulb,
  FaWaveSquare,
  FaPlayCircle,
  FaKeyboard,
  FaGlobe,
  FaMemory
};

const mapIcons = (items) => {
  return items.map(item => ({
    ...item,
    icon: iconMap[item.icon],
  }));
};

export const sections = [
  {
    id: "linux",
    name: "Linux",
    color: "red",
    icon: FaLinux,
    viewAllLink: "/linux-all",
    items: mapIcons(linuxData),
  },
  {
    id: "networking",
    name: "Computer Networks",
    color: "green",
    icon: FaSitemap,
    viewAllLink: "/networking-all",
    items: mapIcons(networkingData),
  },
  {
    id: "python",
    name: "Python3",
    color: "yellow",
    icon: FaPython,
    viewAllLink: "/python-all",
    items: mapIcons(pythonData),
  },
  {
    id: "ai",
    name: "AI Visualizations",
    color: "purple",
    icon: FaBrain,
    viewAllLink: "/ai-all",
    items: mapIcons(aiData),
  },
  {
    id: "gcp",
    name: "Google Cloud Platform",
    color: "blue",
    icon: SiGooglecloud,
    viewAllLink: "/gcp-all",
    items: mapIcons(gcpData),
  }
];

